import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=d878773c"
import script from "./Edit.ts?vue&type=script&lang=ts&external"
export * from "./Edit.ts?vue&type=script&lang=ts&external"
import style0 from "./Edit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports